import { FunctionComponent, ElementType, ReactNode } from "react";

interface IPageTitleProps {
    title: string | ReactNode;
    ActionButton?: ElementType;
    ActionButtonProps?: any;
}

const PageTitle: FunctionComponent<IPageTitleProps> = ({ title, ActionButton, ActionButtonProps }) => (
    <div className="w-[100%] flex flex-col justify-around items-center lg:flex-row lg:justify-between border-bottom pb-3 py-2 mb-3">
        <h1 className="font-sans text-center lg:text-left text-2xl md:text-3xl lg:text-4xl uppercase">{title}</h1>
        {ActionButton && <ActionButton {...ActionButtonProps} />}
    </div>
);

export default PageTitle;